import { FC } from "react";
import { Skeleton } from "src/atoms/Skeleton";
import { StyledProductSidebarSkeleton } from "./ProductSidebarSkeleton.styled";

interface Props {
  className?: string;
}

const ProductSidebarSkeleton: FC<Props> = ({ className }) => {
  return (
    <StyledProductSidebarSkeleton className={className}>
      <div className="labels">
        <Skeleton className="label1" />
        <Skeleton className="label2" />
      </div>
      <Skeleton className="brandName" />
      <Skeleton className="productName" />
      <Skeleton className="price" />
      <Skeleton className="order" />
      <Skeleton className="meta" />
      <Skeleton className="meta" />
      <Skeleton className="meta" />
      <div className="buttons">
        <Skeleton className="button" />
        <Skeleton className="button" />
      </div>
    </StyledProductSidebarSkeleton>
  );
};

export default ProductSidebarSkeleton;
